var _filter, _rect, _path, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DCalendarPastel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f0f4ff",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 20,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.1
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 100,
    width: 240,
    height: 220,
    rx: 40,
    fill: "url(#grad1)",
    filter: "url(#shadow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 140 C 80 120, 320 120, 320 140 L 320 180 L 80 180 Z",
    fill: "#EEF2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 20,
    height: 60,
    rx: 10,
    fill: "#C7D2FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 70,
    width: 20,
    height: 60,
    rx: 10,
    fill: "#C7D2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E0E7FF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 210,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 210,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 210,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 265,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 265,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 265,
    width: 30,
    height: 30,
    rx: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DCalendarPastel);
export default __webpack_public_path__ + "static/media/3d_calendar_pastel.293d71053ed3f5864a64b7278618daba.svg";
export { ForwardRef as ReactComponent };